// extracted by mini-css-extract-plugin
module.exports = {"richTextOutput":"src-components-UI-RTE-Output-styles-style-module__richTextOutput--1LhJw"};